import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-heading font-bold text-sm">
                  N
                </span>
                <span className="font-heading font-semibold text-background-50 text-base">
                  NTR 深度解析
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                致力于为中文用户提供最全面、最深入的NTR文化知识，帮助每一位读者系统性地理解这一独特的ACG文化现象。
              </p>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">
                内容分类
              </h4>
              <ul className="flex flex-col gap-2">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">
                快速链接
              </h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">
                    网站首页
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">
                声明
              </h4>
              <p className="text-sm text-background-400 leading-relaxed">
                本站为NTR文化知识性百科网站，所有内容仅供学习参考与文化交流之用。我们倡导理性、客观地看待ACG文化中的各类现象。
              </p>
            </div>
          </div>

          <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} NTR 深度解析. 保留所有权利.
            </p>
            <p className="text-xs text-background-500">
              本站为知识性百科，内容仅供参考交流
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}